/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const Dashboard: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8.0361 0.002C8.0351 0.002 8.0331 0 8.0311 0C8.0301 0 8.0281 0.001 8.0271 0.001C8.0181 0.001 8.0091 0 8.0001 0C3.5821 0 9.91821e-05 3.582 9.91821e-05 8C9.91821e-05 12.418 3.5821 16 8.0001 16C12.4181 16 16.0001 12.418 16.0001 8C16.0001 3.594 12.4381 0.022 8.0361 0.002ZM1.4051 5.677C1.6291 5.752 2.6041 6.223 2.8051 6.278C3.2471 6.4 3.6591 6.294 3.8591 5.765C4.0371 5.292 3.8741 4.839 3.3881 4.577C3.2281 4.489 2.2581 4.008 2.2581 4.008C3.3421 2.453 5.0411 1.362 7.0001 1.08V2C7.0001 2.552 7.4481 3 8.0001 3C8.5521 3 9.0001 2.552 9.0001 2V1.08C12.3871 1.568 15.0001 4.481 15.0001 8C15.0001 8.34 14.9671 8.672 14.9201 9H11.9901C10.9901 9 10.4301 10.095 10.3531 10.326C10.0911 11.109 9.9891 11.998 7.9951 12C6.0001 11.998 5.8981 11.109 5.6371 10.326C5.5601 10.095 5.0001 9 4.0001 9H1.0801C1.0331 8.672 1.0001 8.34 1.0001 8C1.0001 7.185 1.1471 6.405 1.4051 5.677ZM7.9991 10.008C8.2991 10.008 8.5601 9.87 8.7431 9.661L8.7561 9.672L11.9581 4.547C12.1391 4.186 11.7011 3.834 11.3851 4.085L7.3591 8.263C7.1441 8.446 7.0001 8.708 7.0001 9.012C7.0001 9.562 7.4471 10.008 7.9991 10.008Z'
			/>
		</Svg>
	);
};

export { Dashboard };
